import { render, staticRenderFns } from "./ConsultaHome.vue?vue&type=template&id=41ed00ff&"
import script from "./ConsultaHome.vue?vue&type=script&lang=js&"
export * from "./ConsultaHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports